export const heroData = {
  logo: "/assets/images/biostat.png",
  banner: "/assets/images/hero-banner.webp",
  welcomeText: "Welcome to BioStat House",
  title: "Trusted Medical Statistics for Better Research",
  subtitle:
    "From clinical studies to academic projects, we turn numbers into insights.",
  cta: "https://wa.me/201070101097",
};
